import { state } from './modals.state';
import { mutations } from './modals.mutations';
import { getters } from './modals.getters';
import { actions } from './modals.actions';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
